import React from "react";
import { typeAssets } from "../../assets/type_assets";

export const Header = ({ title = "", numberCart = 0 }) => {
	return (
		<div className={`flex justify-center items-center py-3 bg-secondary_purple boxShadowHeader bg-primary`}>
			<div>
				<img className="h-9" src={typeAssets.general.logo} alt="logo" />
			</div>
		</div>
	);
};
